export function prettyPrintPhone(phone: number): any {
  let segments = `${phone}`.replace(/\D/g, '').match(/^(\d{3})(\d{3})(\d{4})$/);
  return segments ? `(${segments[1]}) ${segments[2]}-${segments[3]}` : null;
}

interface PrettyPrintDateOptions {
  partialYear?: boolean,
  time?: boolean,
  fs?: boolean
}

export function prettyPrintDate(date?: any, options?: PrettyPrintDateOptions): string {
  if (typeof date == 'object' && !date.getTime)
      (options = date), (date = undefined);

  let opts = typeof date == 'object' && !date.getTime ? date : options;
  let d = !date ? new Date() : typeof date == 'object' ? date : new Date(date);

  let year = d.getFullYear();
  if (options?.partialYear) year = year.toString().substring(2);
  let str = `${d.getMonth() + 1}/${d.getDate()}/${year}`;

  if (opts?.time)
      str += ` ${d.getHours() % 12 || '12'}:${d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()} ${d.getHours() >= 12 ? 'PM' : 'AM'}`;
  if (opts?.fs)
      str = str.replaceAll('/', '-').replaceAll(':', '.');

  return str;
}

export function formatSubscriptionStatus(subInfo: any, partialYear?: boolean): string {
  if (!subInfo) return;

  switch (subInfo.bs_status) {
      case 'active':
          return 'Active';
      case 'eot':
          const eot = subInfo.bs_eot;
          if (Date.now() > eot)
              return 'Cancelled';
          return `Expires ${prettyPrintDate(eot, { time: true, partialYear })}`;
      case 'cancelled':
          return 'Cancelled'
      default:
          return 'Inactive';
  }
}

export function prettyPrintZip(zip, country){
if(country == 'USA')
  return zip;
if(country == 'CAN'){
  let str = zip.replace(' ', '').replace('-', '');
  let a = str.substring(0, 3),
      b = str.substring(3);
  return `${a} ${b}`.toUpperCase();
}
return zip;
}